// components/modals/RefundConfirmModal.jsx

import React from "react";
import { XCircle } from "lucide-react";

const RefundConfirmModal = ({ isOpen, onClose, onConfirm, isLoading }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-dry border border-border shadow-2xl rounded-3xl w-[90%] max-w-md overflow-hidden animate-fadeIn">
        {/* Header */}
        <div className="px-6 pt-6">
          {/* Top */}
          <div className="flex items-start gap-4">
            {/* Icon */}
            <div className="shrink-0 w-14 h-14 rounded-2xl bg-red-50 border border-red-100 flex items-center justify-center shadow-sm">
              <XCircle className="w-7 h-7 text-red-500" />
            </div>

            {/* Content */}
            <div className="flex-1">
              <div className="flex items-center justify-between gap-3">
                <h2 className="text-xl font-bold text-navy tracking-tight">
                  Confirm Refund
                </h2>
              </div>

              <p className="text-sm text-gray-500 mt-2 leading-relaxed">
                You are about to refund this payment to the customer. This
                action is permanent and cannot be reversed.
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-border mt-5" />
        </div>

        {/* Footer */}
        <div className="flex gap-3 p-6 mt-2">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="flex-1 h-12 rounded-xl border border-border bg-white hover:bg-gray-100 transition font-medium text-gray-700 disabled:opacity-50"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="flex-1 h-12 rounded-xl bg-red-600 hover:bg-red-700 transition text-white font-semibold disabled:opacity-50"
          >
            {isLoading ? "Processing..." : "Refund"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RefundConfirmModal;
